// Define a function 'URL_Join' to join URL parts and handle various cases.
const URL_Join = (...args) =>
  // Join the URL parts with a forward slash, then perform several replacements to handle different URL formatting cases.
  args
    .join('/')
    .replace(/[\/]+/g, '/') // Replace multiple slashes with a single slash.
    .replace(/^(.+):\//, '$1://') // Add a slash after the scheme if missing.
    .replace(/\?/g, '&') // Replace the first occurrence of '?' with '&'.
    .replace('&', '?') // If there are multiple query parameters, replace the first '&' with '?'.
    .replace(/\/?(\?|#|$)/, '/$1') // Add trailing slash when there is no query string
    .replace(/\/(\?|&|#[^!])/g, '$1'); // Remove slashes before query parameters or fragments.

const pathTranslations = {
  '/opiniones-clientes/': '/customer-reviews/',
  '/opiniones-clientes/particulares/': '/customer-reviews/individuals/',
  '/opiniones-clientes/empresas/': '/customer-reviews/companies/',
  '/particulares/': '/individuals/',
  '/empresas/': '/companies/',
  '/sobre-nosotros/': '/about-us/',
  '/socios-instaladores/': '/technicians/',
  '/contacto/': '/contact/',
  '/placas-solares/instalacion/': '/en/solar-panels/installation/',
  '/soporte-tecnico/': '/technical-support/',
};

const getEnPagePath = (esPath) => {
  return getPathForOtherLanguage(esPath, 'en');
};

const getEsPagePath = (enPath) => {
  return getPathForOtherLanguage(enPath, 'es');
};

const getPathForOtherLanguage = (currentPath, language) => {
  if (language === 'en') {
    return pathTranslations[currentPath] || currentPath;
  }
  // Reverse the keys and values for Spanish to English mapping
  const esToEnMapping = Object.fromEntries(
    Object.entries(pathTranslations).map(([es, en]) => [en, es]),
  );
  return esToEnMapping[currentPath] || currentPath;
};

const getLangSlug = (language) => (language === 'es' ? '' : language);

const getSlugWithoutLang = (slug) => slug.replace(/^(\/?)(en|es)(\/|$)/, '/');

module.exports = {
  URL_Join,
  getEnPagePath,
  getEsPagePath,
  getPathForOtherLanguage,
  getLangSlug,
  getSlugWithoutLang,
};
